module.exports = __webpack_public_path__ + "img/y-62.191a18a0.png";